/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuySharedFAQ_buyPage = {
    readonly meta: {
        readonly header: string | null;
    } | null;
    readonly questionsAnswers: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"BuySharedFAQQuestion_question">;
    } | null> | null;
    readonly " $refType": "BuySharedFAQ_buyPage";
};
export type BuySharedFAQ_buyPage$data = BuySharedFAQ_buyPage;
export type BuySharedFAQ_buyPage$key = {
    readonly " $data"?: BuySharedFAQ_buyPage$data;
    readonly " $fragmentRefs": FragmentRefs<"BuySharedFAQ_buyPage">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuySharedFAQ_buyPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MetaData",
      "kind": "LinkedField",
      "name": "meta",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "header",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "QuestionType",
      "kind": "LinkedField",
      "name": "questionsAnswers",
      "plural": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "BuySharedFAQQuestion_question"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'a1b265e027e778ba240a4202b621ae90';
export default node;
